module.exports = __webpack_public_path__ + "img/lv2-1.e280ff29.png";